import type { GridStackWidget } from 'gridstack';
import { SensorData } from '../../Components/Dashboard/dashboardTypes';

/**
 * Creates a new Data Run to push sensor data in to
 *
 * @constructor
 * @param {number} programId - program id for the program run
 */
class DataRun {
  runId: number;
  programId: string;
  data: SensorData[];
  dashboardLayout: GridStackWidget[];
  lastData: SensorData | null;

  constructor(programId: string) {
    this.runId = Date.now();
    this.programId = programId;
    this.data = [];
    this.dashboardLayout = [];
    this.lastData = null;
  }

  /**
   * Appends a sensor sample to this run.
   *
   * @param {SensorData} newData - a robot sensor data object
   */
  addData(newData: SensorData) {
    const data = { ...newData };
    this.data.push(data);
    this.lastData = data;
  }
}

export default DataRun;
